function saveData() {
    // URLのパス部分を取得する
    let pathSegments = window.location.pathname.split("/").filter(function (segment) {
        return !(segment === "");
    });

    // 配列の最後の値を取得する
    let lastIndex = pathSegments.length - 1;

    // 配列に含まれる数値を取得
    let questionNumberStr = pathSegments[lastIndex];

    let questionColumnArray = Array.prototype.slice.call(document.getElementsByClassName("question-column"));
    questionColumnArray.forEach(function (columnElem, columnIndex) {
        let fieldArray = columnElem.querySelectorAll('[name="' + (columnIndex + 1).toString() + '"]');
        fieldArray.forEach(function (fieldElem, fieldIndex) {
            fieldElem.addEventListener("click", function (event) {
                let dataStr = localStorage.getItem("question");
                let dataJson = JSON.parse(dataStr);
                if(dataJson.questionSectionNumber === questionNumberStr) {
                    dataJson.questionArray[columnIndex] = event.target.value;
                    localStorage.setItem("question", JSON.stringify(dataJson));
                }
            });
        });
    });
}

function loadData() {
    // URLのパス部分を取得する
    let pathSegments = window.location.pathname.split("/").filter(function (segment) {
        return !(segment === "");
    });

    // 配列の最後の値を取得する
    let lastIndex = pathSegments.length - 1;

    // 配列に含まれる数値を取得
    let questionNumberStr = pathSegments[lastIndex];

    // localStorageが存在するかを確認
    if(localStorage.getItem('question')) {
        // 値を取得しJSON形式に変換する
        let dataStr = localStorage.getItem("question");
        let dataJson = JSON.parse(dataStr);

        // 保存している大問の値を比較する
        if (dataJson.questionSectionNumber === questionNumberStr) {
            let questionArray = dataJson.questionArray;
            let questionColumnArray = Array.prototype.slice.call(document.getElementsByClassName("question-column"));
            questionColumnArray.forEach(function (columnElem, columnIndex) {
                let fieldArray = columnElem.querySelectorAll(`[name="${(columnIndex + 1).toString()}"]`);
                if ((questionArray[columnIndex])) {
                    fieldArray.forEach(function (fieldElem, fieldIndex) {
                        if(fieldElem.value === questionArray[columnIndex]) {
                            if(fieldElem.value === "5") {
                                if (fieldElem.classList.contains("do-not-know")) {
                                    fieldElem.checked = true;
                                }
                            } else {
                                fieldElem.checked = true;
                            }
                        }
                    });
                }
            });
        } else {
            // localStorageの初期化
            dataJson.questionSectionNumber = questionNumberStr;
            dataJson.questionArray = [];
            localStorage.setItem('question', JSON.stringify(dataJson));
        }
    } else {
        // localStorageの初期化
        let data = {};
        data.questionSectionNumber = questionNumberStr;
        data.questionArray = [];
        localStorage.setItem('question', JSON.stringify(data));
    }

}

export function questionSaveTool() {
    saveData();
    loadData();
}
